import { Box, Flex } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { ICustomStyle } from 'src/components/App/Wrapper/Wrapper';
import { Explorer } from 'src/components/Explorer/explorer';
import { ActionBackIcon } from 'src/utils/icons/actionBack';

export const SearchPane = ({ customStyle }: ICustomStyle) => {
	const navigate = useNavigate();

	return (
		<Flex
			gridGap="12px"
			justifyContent="center"
			background={customStyle?.bg}
			padding="12px"
			alignItems="center"
		>
			<Box
				zIndex={5}
				onClick={() => navigate(-1)}
			>
				<ActionBackIcon color={customStyle?.text} />
			</Box>
			<Explorer customStyle={customStyle} />
		</Flex>
	);
};
